import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MessageProvider {

  constructor() { }
  
  private message = new Subject<any>();
  private warning = new Subject<any>();
  private error = new Subject<any>();
  
  notifyMessage(message: string) {
      this.message.next(message);
  }

  clearMessage() {
      this.message.next();
  }

  getMessage(): Observable<any> {
      return this.message.asObservable();
  }
  
  notifyWarning(warn: string) {
      this.warning.next(warn);
  }

  clearWarning() {
      this.warning.next();
  }

  getWarning(): Observable<any> {
      return this.warning.asObservable();
  }
  
  notifyError(err: string) {
      this.error.next(err);
  }

  clearError() {
      this.error.next();
  }

  getError(): Observable<any> {
      return this.error.asObservable();
  }
  
  clearAll() {
      this.clearMessage();
      this.clearWarning();
      this.clearError();
  }
}



// WEBPACK FOOTER //
// ./src/app/service/message.service.ts